module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mceltis17-f6423f93dc0f85a8cd00f30d4d772108.jpg";